import React, { useState, useEffect } from 'react';
import {ToastContainer, toast, Slide} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import ReportBuilder from '../../components/FormPage/ReportQueryBuilder.js';
import FeatureBuilder from '../../components/FormPage/FeatureQueryBuilder.js';
import RTPBuilder from '../../components/FormPage/RTPQueryBuilder.js';
import CPBuilder from '../../components/FormPage/CPQueryBuilder.js';
import AlertPage from '../../containers/Pages/AlertPage.js';

export default function QueryBuilder() {
  const location = useLocation();
  // page State: report, features, alerts
  const [queryPage, setQueryPage] = useState("features");
  // reports
  const [name, setName] = useState('');
  const [sql, setSql] = useState('');
  const [recurrence, setRecurrence] = useState('daily');
  const [hostList, setHostList] = useState([]);
  const [host, setHost] = useState('');
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [example, setExample] = useState([]);
  const [tableDetails, setTableDetails] = useState([]);
  const [columns, setColumns] = useState([]);
  //features
  // [{queryId: Q1, queryDescription: Transaction Total, queryText: Select * from table.transactions;, columns: 1}...]
  const [selectedQuery, setSelectedQuery] = useState(
	{
		QueryType: "MYSQL",
		QueryDescription: "Select Query",
		QueryText: "",
		Columns: 0,
		i: 0,
		QueryId: 0,
		IdType: "Party",
		ReturnType: "Number",
		Category: "Alert",
	});
  const [isNewQuery, setIsNewQuery] = useState(false);
  const [queryList, setQueryList] = useState([]);
  const [queryType, setQueryType] = useState("");
  const [queryDescription, setQueryDescription] = useState("");
  const [queryText, setQueryText] = useState("");
  const [queryColumns, setQueryColumns] = useState("");
  const [queryId, setQueryId] = useState("");
  const [idType, setIdType] = useState("");
  const [returnType, setReturnType] = useState("");
  const [category, setCategory] = useState("");
  const [availableQueryTypes, setAvailableQueryTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [idTypes, setIdTypes] = useState([]);
  const [tab, setTab] = useState('select');
  const [RTPList, setRTPList] = useState([]);
  const [CounterpartyList, setCounterpartyList] = useState([]);
  const [detailType, setDetailType] = useState('mysql')

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const featureId = params.get('featureId');
    const page = params.get('page');
    
    if (featureId) {
      setQueryPage('features');
      setTab('build');
      
      // Fetch the specific feature query
      axios.get(`/api/queries/`)
        .then(res => {
          if (res.data) {
			setQueryList(res.data);
			const index = res.data.findIndex(item => item.QueryId == featureId) || 0;
			handleQuerySelect({target: {value: index}}, res.data);
          }
        })
        .catch(err => {
          console.error('Error fetching feature query:', err);
          toast('Error fetching feature query');
        });
    }
    
    if (page === 'alerts') {
      setQueryPage('alerts');
      setTab('build');
    }
  }, []);

  const handleQuerySelect = (event, updatedQueryList=null) => {
	  let query = null;
	  const i = parseInt(event.target.value,10);
	  if (updatedQueryList) {
		query = updatedQueryList[i];
	  } else if (queryPage === 'RTP') {
		query = RTPList[i];
	  } else if (queryPage === "CP") {
		query = CounterpartyList[i];
	  } else {
		query = queryList[i];
	  }
	  setSelectedQuery({...query, i});
	  setQueryType(query.QueryType);
	  setQueryDescription(query.QueryDescription);
	  setQueryText(query.QueryText);
	  setQueryColumns(query.Columns);
	  setQueryId(query.QueryId);
	  setIdType(query.IdType);
	  setReturnType(query.ReturnType);
	  setCategory(query.Category);
  };


  const handleSubmit = (event) => {
	  event.preventDefault();
	  axios.post('/api/new_job/', {
		  job_id: name,
		  query: sql,
		  interval: recurrence,
		  user: 'joe'
	  }).then(res => {
		  toast('Query Scheduled Successfully');
	  }).catch(err => {
		  toast('Error scheduling job');
		  console.error(err)
	  })

  };

  const submitNewQuery = (e) => {
	  e.preventDefault();
	  axios.post('/api/queries', {
		  isNewQuery,
		  queryType,
		  queryText,
		  queryDescription,
		  columns: queryColumns,
		  queryId,
		  idType,
		  returnType
	  }).then(res => {
		  toast('Query Submitted Successfully');
	  }).catch(err => {
		  toast('Error Submitting Query');
		  console.error(err);
	  })
  }

	const submitRTP = (e) => {
		e.preventDefault();
		axios.post('/api/RTP', {
		  isNewQuery,
		  queryType,
		  queryText,
		  queryDescription,
		  columns: queryColumns,
		  queryId,
		  idType,
		  returnType
	  }).then(res => {
		  toast('Query Submitted Successfully');
	  }).catch(err => {
		  toast('Error Submitting Query');
		  console.error(err);
	  })
	}

    const submitCounterparty = (e) => {
		e.preventDefault();
		axios.post('/api/COUNTERPARTY', {
		  isNewQuery,
		  queryType,
		  queryText,
		  queryDescription,
		  columns: queryColumns,
		  queryId,
		  idType,
		  returnType
	  }).then(() => {
		  toast('Query Submitted Successfully');
	  }).catch(err => {
		  toast('Error Submitting Query');
		  console.error(err);
	  })
    }

  useEffect(() => {
  	axios.get('/api/connections')
  		.then(res => {
  			setHostList(res.data)
  		})
  }, [])

  useEffect(() => {
	  if (detailType === 'mysql') {
		axios.get('/api/tables')
			.then(res => {
				setTables(res.data)
				setSelectedTable(res.data[0]);
				axios.get(`/api/tableDetails/${res.data[0]}`)
				  .then(res => {
					setExample(res.data.examples);
					setTableDetails(res.data.tableDetails)
					setColumns(res.data.columns)
				  })
			})
	  } else {
		axios.get('/api/pgtables')
			.then(res => {
				setTables(res.data)
				setSelectedTable(res.data[0]);
				axios.get(`/api/pgtableDetails/${res.data[0]}`)
				  .then(res => {
					setExample(res.data.examples);
					setTableDetails(res.data.tableDetails)
					setColumns(res.data.columns)
				  })
			})
	  }
  }, [host, detailType])

  useEffect(() => {
    axios.get('/api/fcategories')
	  	.then(res => {
			if (res.data) {
				setAvailableQueryTypes(res.data.QueryReturnTypes);
				setCategories(res.data.Categories);
				setIdTypes(res.data.IdTypes);
				if (res.data.IdTypes.length) {
					setIdType(res.data.IdTypes[0]);
				};
				if (res.data.QueryReturnTypes.length) {
					setReturnType(res.data.QueryReturnTypes[0]);
				};
				if (res.data.Categories.length) {
					setCategory(res.data.Categories[0]);
				};
			}
		})
  }, []);

  useEffect(() => {
    axios.get('/api/queries')
		  .then(res => {
			if (res.data.length) {
				setSelectedQuery(res.data[0]);
				setQueryList(res.data);
			}
		  })
  }, []);

  useEffect(() => {
	  if (queryPage === 'RTP'){
		axios.get('/api/RTP')
			  .then(res => {
				if (res.data.length) {
					setSelectedQuery(res.data[0]);
					setRTPList(res.data);
				}
			  })
        }
      else if (queryPage === 'CP'){
		axios.get('/api/COUNTERPARTY')
			  .then(res => {
				if (res.data.length) {
					setSelectedQuery(res.data[0]);
					setCounterpartyList(res.data);
				}
			  })
	  } else {
	    axios.get('/api/queries')
			  .then(res => {
				if (res.data.length) {
					setSelectedQuery(res.data[0]);
					setQueryList(res.data);
				}
			  })
	  }
  }, [queryPage]);

  const onTableSelect = (table) => {
	  if (detailType === "mysql") {
		axios.get(`/api/tableDetails/${table}`)
		  .then(res => {
			setSelectedTable(table);
			setExample(res.data.examples);
			setTableDetails(res.data.tableDetails)
			setColumns(res.data.columns)
		  })
	  } else {
		axios.get(`/api/pgtableDetails/${table}`)
		  .then(res => {
			setSelectedTable(table);
			setExample(res.data.examples);
			setTableDetails(res.data.tableDetails)
			setColumns(res.data.columns)
		  })
	  }
  }

  const whichPage = (pageType, props) => {
  	switch (pageType) {
  		case "report":
  			return <ReportBuilder {...props} />;
  		case "features":
  			return <FeatureBuilder {...props} />;
  		case "RTP":
  			return <RTPBuilder {...props} />;
  		case "CP":
  			return <CPBuilder {...props} />;
  		case "alerts":
  			return <AlertPage />;
  		default:
  			return <></>;
  	}

  }

  const whichTitle = (pageType) => {
	switch (pageType) {
		case "report":
			return "Report Query Builder"
		case "features":
			return "Feature Query Builder"
		case "alerts":
			return "Alert Management"
		case "RTP":
			return "RTP Query Builder"
		case "CP":
			return "Counterparty Query Builder"
		default:
			return "Query Builder"
	}
  }
  const getTabClass = (providedTab) => {
	  return providedTab === tab ?
		  "inline-block p-4 text-purple-500 bg-gray-400 rounded-t-lg active"
		  :
	      "inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-300"
  }





  const queryBuilderProps = {
	selectedQuery,
	handleQuerySelect,
	isNewQuery,
	setIsNewQuery,
	queryList,
	queryType,
	setQueryType,
	queryDescription,
	setQueryDescription,
	queryText,
	setQueryText,
	queryColumns,
	setQueryColumns,
	submitNewQuery,
	example,
	queryPage,
	setQueryPage,
	availableQueryTypes,
	categories,
	category,
	setCategory,
	idTypes,
	idType,
	setIdType,
	returnType,
	setReturnType,
	handleSubmit,
	host,
	setHost,
	hostList,
	setName,
	name,
	sql,
	setSql,
	recurrence,
	setRecurrence,
	selectedTable,
	onTableSelect,
	tables,
	columns,
	submitRTP,
	RTPList,
    submitCounterparty,
    CounterpartyList,
  };


  return (

    <div className="p-6 w-4/5" style={{marginLeft: "8rem"}}>
	  <ToastContainer
	  	position="top-center"
	  	transition={Slide}
	  	hideProgressBar={true}
	  	bodyClassName="text-gray-600"
	  	progressClassName="bg-purple-500"
	  />
	  <p className="inline-block p-4 text-purple-500 rounded-t-lg active hover:text-gray-600 hover:bg-gray-300 hidden"></p>

    <h1 className="text-3xl py-4 border-b mb-10">{whichTitle(queryPage)}</h1>
	<ul class="flex flex-wrap text-lg font-medium text-center text-gray-500 border-b border-gray-400 mb-5">
      <li class="mr-3">
		  <button onClick={() => setTab('select')}aria-current="page" className={getTabClass('select')}>Select</button>
      </li>
      <li class="mr-3">
		  <button onClick={() => setTab('build')}className={getTabClass('build')}>Build</button>
      </li>
      <li class="mr-3">
		  <button onClick={() => setTab('view')}className={getTabClass('view')}>View Details</button>
      </li>
	</ul>
	{
		tab === 'select' && (
			<div className="p-5 mb-10 ml-5 bg-white shadow">
			  <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">
				  Select Page
			  </h2>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="pageSelect">
					Query Type
				</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="pageSelect"
				  placeholder={"Report"}
				  value={queryPage}
				  onChange={(event) => setQueryPage(event.target.value)}
				>
				  <option value="report">Report</option>
				  <option value="features">Features</option>
				  <option value="alerts">Alerts</option>
				  <option value="RTP">RTP</option>
				  <option value="CP">Counterparty</option>
				</select>
			  </div>
			</div>
		)
	}
	{tab === 'build' && whichPage(queryPage, queryBuilderProps)}
	{tab === 'view' && (
		<>
			<div className="p-5 mb-10 ml-5 bg-white shadow">
			  <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">
				  Table Details
			  </h2>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="detailSelect">
					Detail Type
				</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="detailSelect"
				  placeholder={"Report"}
				  value={detailType}
				  onChange={(event) => setDetailType(event.target.value)}
				>
				  <option value="mysql">MySQL</option>
				  <option value="postgres">PostgreSQL</option>
				</select>
			  </div>
			  <div className="flex flex-col justify-center px-6 mt-5">
				<label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="tableSelect">Table</label>
				<select
				  className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
				  id="tableSelect"
				  placeholder={"Select a table"}
				  value={selectedTable}
				  onChange={(event) => onTableSelect(event.target.value)}
				>
					{tables.length ?
						tables.map(table => (
							<option value={table}>{table}</option>
						)
					): ""}
				</select>
			  </div>
			  </div>
				{tableDetails.length > 0 && (
				  <div className="w-full overflow-x-scroll mt-5 px-6">
					<h3 className="block tracking-wide text-gray-600 text-xs font-bold mb-2">Table Schema</h3>
					<table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
					  <thead>
						<tr className="text-left">
						  <th className="bg-purple-l sticky top-0 border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-xs">Column Name</th>
						  <th className="bg-purple-l sticky top-0 border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-xs">Data Type</th>
						</tr>
					  </thead>
					  <tbody>
						{tableDetails.map((column, index) => (
						  <tr key={index}>
							<td className="border-dashed border-t border-gray-200">
								<span className="text-gray-800 px-6 py-3 flex items-center">
									{column[0]}
								</span>
							</td>
							<td className="border-dashed border-t border-gray-200">
								<span className="text-gray-800 px-6 py-3 flex items-center">
									{column[1]}
								</span>
							</td>
						  </tr>
						))}
					  </tbody>
					</table>
				  </div>
				)}

				{columns.length > 0 && example.length > 0 && (
				  <div className="w-full overflow-x-scroll mt-5 px-6">
					<h3 className="block tracking-wide text-gray-600 text-xs font-bold mb-2">Sample Rows</h3>
					<table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
					  <thead>
						<tr className="text-left">
						  {columns.map((key, index) => (
							<th className="bg-purple-l sticky top-0 border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-xs" key={index}>{key}</th>
						  ))}
						</tr>
					  </thead>
					  <tbody>
						{example.map((row, index) => (
						  <tr key={index}>
							{row.map((value, index) => (
							  <td className="border-dashed border-t border-gray-200" key={index}>
								<span className="text-gray-800 px-6 py-3 flex items-center">
								  {typeof value === 'object' ? JSON.stringify(value) : value}
								</span>
							  </td>
							))}
						  </tr>
						))}
					  </tbody>
					</table>
				  </div>
				)}
		</>
	)}
    </div>
  );
};
